import { Tab, styled } from '@mui/material';

interface StyledTabProps {
  variant?: 'tab' | 'button';
  btnMargin?: string;
}

export const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<StyledTabProps>(({ theme, variant = 'tab', btnMargin = '0 5px' }) => ({
  ...(variant === 'tab' && {
    '&.Mui-selected': {
      color: 'black !important',
      fontWeight: 'bold',
      backgroundColor: 'white',
      borderTop: '4px solid #4476ad',
      borderRadius: '0px',
      marginBottom: '-1px',
      paddingBottom: '14px',
      borderLeft: `1px solid ${theme.palette.border.input}`,
      borderRight: `1px solid ${theme.palette.border.input}`,
    },
  }),
  ...(variant === 'button' && {
    border: '1px solid black',
    color: 'black !important',
    backgroundColor: '#ffffff',
    margin: btnMargin,
    '&.Mui-selected': {
      color: 'white !important',
      backgroundColor: '#4476ac',
    },
  }),
}));
